import React from "react";
import "./ServicesPage.css";
import architectureImage from "../assets/whatwedo/project-gallery-04.png";
import interiorDesignImage from "../assets/whatwedo/kids-room.png";
import visualisationImage from "../assets/aurangabad-house/ChatGPT Image Sep 4, 2026, 05_50_02 PM.png";
// import spacePlanningImage from "../assets/atelier-apartment.jpg";
import renovationImage from "../assets/whatwedo/renovation.png";
import turnkeyDesignImage from "../assets/whatwedo/turnkey.png";
import SiteCrews from "../components/SiteCrews/SiteCrews";


/**
 * ServicesPage
 * Standalone "Services" page, converted from the original bundled site.
 * All copy/content is written directly where it appears in the JSX
 * (no data pulled from array constants), and every CSS class is
 * scoped/prefixed with "svcp-" so it can't collide with other styles.
 */
export default function ServicesPage() {
  return (
    <div className="svcp-root">
      {/* ---------------- Hero ---------------- */}
      <header className="svcp-wrap svcp-hero">
        <p className="svcp-label">Capability — Six disciplines</p>
        <h1 className="svcp-display svcp-d-xl svcp-hero-title">
          From first line to <span className="svcp-italic">handover</span>.
        </h1>
        <p className="svcp-lede svcp-hero-lede">
          Each discipline below can be commissioned alone — though they were
          designed to be commissioned together.
        </p>
      </header>

       <SiteCrews />


      {/* ---------------- Service 01 — Architecture ---------------- */}
      <section className="svcp-wrap">
        <div className="svcp-chapter">
          <div className="svcp-chapter-media">
            <div className="svcp-chapter-img">
              <img
                src={architectureImage}
                alt="Architecture — studio work"
                loading="lazy"
              />
            </div>
          </div>
          <div className="svcp-chapter-body">
            <p className="svcp-label svcp-chapter-eyebrow">01 — Service</p>
            <h2 className="svcp-display svcp-d-md svcp-chapter-title">
              Architecture
            </h2>
            <p className="svcp-lede svcp-chapter-desc">
              From site reading to construction administration, we design
              buildings whose form is inseparable from how they are made and
              where they stand.
            </p>

            <p className="svcp-label svcp-sublabel">Capabilities</p>
            <ul className="svcp-pill-list">
              <li>Site &amp; context study</li>
              <li>Massing</li>
              <li>Structural coordination</li>
              <li>Facade systems</li>
            </ul>

            <p className="svcp-label svcp-sublabel">Deliverables</p>
            <ul className="svcp-pill-list">
              <li>Concept set</li>
              <li>GFC drawings</li>
              <li>Detail library</li>
              <li>Site supervision</li>
            </ul>

            {/* <button type="button" className="svcp-cta">
              <span>Enquire about architecture</span>
            </button> */}
          </div>
        </div>
      </section>

      {/* ---------------- Service 02 — Interior Design ---------------- */}
      <section className="svcp-wrap">
        <div className="svcp-chapter svcp-flip">
          <div className="svcp-chapter-media">
            <div className="svcp-chapter-img">
              <img
                src={interiorDesignImage}
                alt="Interior Design — studio work"
                loading="lazy"
              />
            </div>
          </div>
          <div className="svcp-chapter-body">
            <p className="svcp-label svcp-chapter-eyebrow">02 — Service</p>
            <h2 className="svcp-display svcp-d-md svcp-chapter-title">
              Interior Design
            </h2>
            <p className="svcp-lede svcp-chapter-desc">
              Spatial planning, joinery, material and light developed as one
              continuous body of work rather than a finishing layer.
            </p>

            <p className="svcp-label svcp-sublabel">Capabilities</p>
            <ul className="svcp-pill-list">
              <li>Spatial planning</li>
              <li>Bespoke joinery</li>
              <li>Material palettes</li>
              <li>Lighting design</li>
            </ul>

            <p className="svcp-label svcp-sublabel">Deliverables</p>
            <ul className="svcp-pill-list">
              <li>Layouts</li>
              <li>Joinery drawings</li>
              <li>Material board</li>
              <li>FF&amp;E schedule</li>
            </ul>

            {/* <button type="button" className="svcp-cta">
              <span>Enquire about interior design</span>
            </button> */}
          </div>
        </div>
      </section>

      {/* ---------------- Service 03 — Project Management Consultancy (PMC) ---------------- */}
      <section className="svcp-wrap">
        <div className="svcp-chapter">
          <div className="svcp-chapter-media">
            <div className="svcp-chapter-img">
              <img
                src={visualisationImage}
                alt="Project Management Consultancy (PMC) — studio work"
                loading="lazy"
              />
            </div>
          </div>
          <div className="svcp-chapter-body">
            <p className="svcp-label svcp-chapter-eyebrow">03 — Service</p>
            <h2 className="svcp-display svcp-d-md svcp-chapter-title">
              Project Management Consultancy (PMC)
            </h2>
            <p className="svcp-lede svcp-chapter-desc">
              From planning and contractor coordination to quality checks and timelines, every stage is managed to keep the project efficient, precise, and on track.
            </p>

            <p className="svcp-label svcp-sublabel">Capabilities</p>
            <ul className="svcp-pill-list">
              <li>Daylight studies</li>
              <li>Material tests</li>
              <li>Camera composition</li>
              <li>Walkthroughs</li>
            </ul>

            <p className="svcp-label svcp-sublabel">Deliverables</p>
            <ul className="svcp-pill-list">
              <li>Still renders</li>
              <li>Comparison sets</li>
              <li>Animation</li>
              <li>VR stills</li>
            </ul>

            {/* {/* <button type="button" className="svcp-cta">
              <span>Enquire about 3d visualisation</span>
            </button> */}
          </div>
        </div>
      </section>

       {/* ---------------- Service 05 — Renovation ---------------- */}
      <section className="svcp-wrap">
        <div className="svcp-chapter">
          <div className="svcp-chapter-media">
            <div className="svcp-chapter-img">
              <img
                src={renovationImage}
                alt="Renovation — studio work"
                loading="lazy"
              />
            </div>
          </div>
          <div className="svcp-chapter-body">
            <p className="svcp-label svcp-chapter-eyebrow">04 — Service</p>
            <h2 className="svcp-display svcp-d-md svcp-chapter-title">
              Renovation
            </h2>
            <p className="svcp-lede svcp-chapter-desc">
              We work with the existing structure — removing what obstructs,
              keeping what carries memory.
            </p>

            <p className="svcp-label svcp-sublabel">Capabilities</p>
            <ul className="svcp-pill-list">
              <li>Existing survey</li>
              <li>Structural strategy</li>
              <li>Services upgrade</li>
              <li>Phasing</li>
            </ul>

            <p className="svcp-label svcp-sublabel">Deliverables</p>
            <ul className="svcp-pill-list">
              <li>As-built set</li>
              <li>Intervention drawings</li>
              <li>Phase plan</li>
              <li>Cost bands</li>
            </ul>

            {/* <button type="button" className="svcp-cta">
              <span>Enquire about renovation</span>
            </button> */}
          </div>
        </div>
      </section>

      {/* ---------------- Service 04 — Space Planning ---------------- */}
      {/* <section className="svcp-wrap">
        <div className="svcp-chapter svcp-flip">
          <div className="svcp-chapter-media">
            <div className="svcp-chapter-img">
              <img
                src={spacePlanningImage}
                alt="Space Planning — studio work"
                loading="lazy"
              />
            </div>
          </div>
          <div className="svcp-chapter-body">
            <p className="svcp-label svcp-chapter-eyebrow">04 — Service</p>
            <h2 className="svcp-display svcp-d-md svcp-chapter-title">
              Space Planning
            </h2>
            <p className="svcp-lede svcp-chapter-desc">
              Adjacency, circulation and daylight tested across options until
              the plan works effortlessly in use.
            </p>

            <p className="svcp-label svcp-sublabel">Capabilities</p>
            <ul className="svcp-pill-list">
              <li>Programme briefing</li>
              <li>Adjacency studies</li>
              <li>Circulation</li>
              <li>Option testing</li>
            </ul>

            <p className="svcp-label svcp-sublabel">Deliverables</p>
            <ul className="svcp-pill-list">
              <li>Block plans</li>
              <li>Furniture layouts</li>
              <li>Area statement</li>
              <li>Option report</li>
            </ul>

            <button type="button" className="svcp-cta">
              <span>Enquire about space planning</span>
            </button>
          </div>
        </div>
      </section> */}

     

      {/* ---------------- Service 06 — Turnkey Design ---------------- */}
      <section className="svcp-wrap">
        <div className="svcp-chapter svcp-flip">
          <div className="svcp-chapter-media">
            <div className="svcp-chapter-img">
              <img
                src={turnkeyDesignImage}
                alt="Turnkey Design — studio work"
                loading="lazy"
              />
            </div>
          </div>
          <div className="svcp-chapter-body">
            <p className="svcp-label svcp-chapter-eyebrow">05 — Service</p>
            <h2 className="svcp-display svcp-d-md svcp-chapter-title">
              Turnkey Design
            </h2>
            <p className="svcp-lede svcp-chapter-desc">
              Procurement, fabrication and site execution held by one team so
              the drawn intent survives the build.
            </p>

            <p className="svcp-label svcp-sublabel">Capabilities</p>
            <ul className="svcp-pill-list">
              <li>Vendor curation</li>
              <li>Procurement</li>
              <li>Site execution</li>
              <li>Snagging</li>
            </ul>

            <p className="svcp-label svcp-sublabel">Deliverables</p>
            <ul className="svcp-pill-list">
              <li>Budget model</li>
              <li>Programme</li>
              <li>Weekly reports</li>
              <li>Handover file</li>
            </ul>

            {/* <button type="button" className="svcp-cta">
              <span>Enquire about turnkey design</span>
            </button> */}
          </div>
        </div>
      </section>

      {/* ---------------- Working method / process ---------------- */}
      <section className="svcp-band-dark">
        <div className="svcp-wrap">
          <div className="svcp-section-head">
            <h2 className="svcp-display svcp-d-md">Working method</h2>
            <p className="svcp-label">Same for every service</p>
          </div>

          <div className="svcp-process">
            <div className="svcp-process-step">
              <span className="svcp-label svcp-step-n">01</span>
              <h4>Discover</h4>
              <p>Site, brief, constraints and the client&rsquo;s way of living.</p>
            </div>

            <div className="svcp-process-step">
              <span className="svcp-label svcp-step-n">02</span>
              <h4>Define</h4>
              <p>Programme, area logic and the project&rsquo;s non-negotiables.</p>
            </div>

            <div className="svcp-process-step">
              <span className="svcp-label svcp-step-n">03</span>
              <h4>Concept</h4>
              <p>A single spatial idea, tested against everything.</p>
            </div>

            <div className="svcp-process-step">
              <span className="svcp-label svcp-step-n">04</span>
              <h4>Develop</h4>
              <p>Plans, sections and details resolved with consultants.</p>
            </div>

            <div className="svcp-process-step">
              <span className="svcp-label svcp-step-n">05</span>
              <h4>Visualise</h4>
              <p>Light, tone and material judged before construction.</p>
            </div>

            <div className="svcp-process-step">
              <span className="svcp-label svcp-step-n">06</span>
              <h4>Execute</h4>
              <p>Site, fabrication and handover under one team.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
